import { connect } from 'react-redux'
import { ReportsListComponent } from './ReportsList'
import { ReportRouteProps } from '../Router/Router'
import { loadReportList } from './actions/LoadReportList'
import { replaceReport } from './actions/ReplaceReport'
import { deleteReport } from './actions/DeleteReport'
import { withRouter } from 'react-router'
import * as _ from 'lodash'
import { RootState } from '../../reducers/root-reducer'
import { StateProps } from './ReportsList'

const mapStateToProps = (state: RootState, ownProps: ReportRouteProps) : StateProps => {
  const markets = state.report.reportGroups
  const market =
    ownProps.match.params.market || _.keys(markets).length === 0
      ? ownProps.match.params.market
      : _.keys(markets)[0]
  const reportGroups = markets ? markets[market] : undefined
  const reportGroup =
    ownProps.match.params.reportGroup || !reportGroups || reportGroups.length === 0
      ? ownProps.match.params.reportGroup
      : reportGroups[0].key
  return {
    reportList: state.report.reports,
    reportsLoading: state.report.reportsLoading,
    error: state.report.errorMessage,
    marketKey: market,
    reportGroupKey: reportGroup,
    reportGroup: reportGroups ? reportGroups.find(r => r.key === reportGroup) : undefined,
    reportGroupsLoading: state.report.reportGroupsLoading,
    marketsLoading: state.market.marketsLoading,
    markets: state.market.markets
  }
}

const mapDispatchToProps = {
  reportsLoad: loadReportList,
  reportDelete: deleteReport,
  reportReplace: replaceReport
}

export const ReportListContainer = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ReportsListComponent)
)
